import { useLink } from 'react-router-stack';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { convertToDollars, isSmartPhone } from '../../utilities/helper';
import { RouteWrapper } from '../../component';
import Bottombar from '../../component/bottom_bar';
import './index_mWeb.css';
import constants from '../../constants';
import NavigationHeader from '../../component/navigation_header';
import ScreenBackgroundWrapper from '../../component/screen_background_wrapper';
import { useSelector } from 'react-redux';
import avatars from '../../constants/avatars';
import Constants from '../../constants';
import useTheme from '../../utilities/hooks/theme';
const MyProfileMWeb = ({ balance, teamName }: any) => {
  const { avatarId } = useSelector((state: any) => state.user);
  const { AccountTheme: theme } = useTheme();

  const navigate = useLink();
  const onClickBack = () => {
    try {
      navigate.push('/');
    } catch (err) {
      navigate.go(-1);
    }
  };
  const withdrawBtnStyle = {
    background: theme.myProfileWithdrawBtnBg,
    border: '1px solid #fff079'
  };
  const yourBalanceCardStyle = {
    background: theme.myProfileYourBalanceBg,
    boxShadow: theme.myProfileYourBalanceBoxShadow,
    border: ` 1px solid ${theme.myProfileYourBalanceBorder}`
  };
  const balanceStripRectangleStyle = {
    border: ` 1px solid ${theme.myProfileYourBalanceBorder}`
  };
  const balanceStripHeaderStyle = {
    background: theme.myProfileTransactionsHeaderBg
  };
  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <NavigationHeader onClickBack={onClickBack} title={'My Profile'} bgColor />

        <div className="accountPage" id="accountPage">
          <div
            className={`${
              isSmartPhone ? 'accountPage__contentWrapper' : 'accountPage__contentWrapper-desktop'
            }`}>
            <div className={`userInfoCard accountPage__userInfoCard`}>
              <div className="row g-0">
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 offset-lg-3">
                  <div className="userInfoCard__box_mWeb">
                    <div className={`avatarSec userInfoCard__rightSec_mWeb`}>
                      <div className="avatarSec__avatarAndEditWrap">
                        <div className="avatarSec__avatarWrap">
                          <img
                            alt="User Logo"
                            className="avatarSec__avatarLogo"
                            src={avatars[avatarId]}
                          />
                        </div>
                        <div
                          className="avatarSec_edit_icon_img_mWeb"
                          onClick={() => navigate.push('/select_avatar')}>
                          <Constants.Svgs.EditAvatar />
                        </div>
                      </div>
                      <div className="avatarSec__nameWrapper">
                        <div>
                          <p className="avatarSec__name avatarSec__avoidNameOverflow">{teamName}</p>
                          <p className="avatarSec__mobileNumber">998756876</p>
                        </div>
                      </div>
                    </div>
                    <div className="userInfoCard__leftSec_mWeb">
                      <div className="first_mWeb">
                        {/* <div className="circle_mWeb">
                          <img className="games_played_mWeb" src={swords} />
                        </div> */}
                        <div className="rectangle_mWeb">
                          <div className="title_mWeb">
                            <span className="games-played_mWeb">Games Played</span>
                          </div>
                          <div className="data_mWeb">
                            <span className="games__played-data_mWeb">___</span>
                          </div>
                        </div>
                      </div>

                      <div className="third_mWeb">
                        <div className="circle_mWeb">
                          <img className="coins_earned_mWeb" src={'/images/swords.webp'} />
                        </div>
                        <div className="rectangle_mWeb">
                          <div className="title_mWeb">
                            <span className="games-played_mWeb">Games Played</span>
                          </div>
                          <div className="data_mWeb">
                            <span className="games__played-data_mWeb">23,233</span>
                          </div>
                        </div>
                      </div>
                      <div className="second_mWeb">
                        <div className="circle_mWeb">
                          <img src={constants.Images.coin} className="games_winnings_mWeb" />
                        </div>
                        <div className="rectangle_mWeb">
                          <div className="title_mWeb">
                            <span className="games-played_mWeb">Games Winnings</span>
                          </div>
                          <div className="data_mWeb">
                            <span className="games__played-data_mWeb">
                              <span className="text-style-1_mWeb"></span>
                              {`${convertToDollars(balance['totalBalance'])}`}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={'accountPage__balanceStripList'}>
              <div className="balanceStrip_mWeb">
                <div className="row g-0">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 offset-lg-6">
                    <div
                      className="balanceStrip__rectangle_mWeb"
                      style={balanceStripRectangleStyle}>
                      <div className="balanceStrip__title_mWeb" style={balanceStripHeaderStyle}>
                        <span className="balanceStrip__heading_mWeb">Your balance</span>
                      </div>
                      <div className="balanceStrip__data_mWeb" style={yourBalanceCardStyle}>
                        <div>
                          <img src={constants.Images.coin} className="balance__image_mWeb" />
                        </div>
                        <div className="balanceStrip_balanceWrap">
                          <span className="text-style-1_mWeb">{`${convertToDollars(
                            balance['totalBalance']
                          )}`}</span>
                        </div>
                        <div
                          className="balance__bottom-button_mWeb"
                          onClick={() => navigate.push('/transaction_history')}>
                          <button
                            className="balance__button_mWeb"
                            style={withdrawBtnStyle}
                            onClick={() => navigate.push('/transaction_history')}>
                            All Transactions <ChevronRightIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="myProfile__withdrawalLimit__txt__mWeb" style={balanceStripHeaderStyle}>
              Withdrawal limit for today {convertToDollars(500)}/-
            </div>
            <div className="myprofile_note_container__mWeb">
              <div className="myprofile__note__title">Note:</div>
              <div className="myprofile__terms__container__mWeb">
                <p>1. It may take up to 48 hours for the winnings to added to your wallet</p>
                <p>2. Common reasons for transaction failure while withdrawing your winnings</p>
                <p className="myProfile__termsRejection__txt_mWeb">
                  You donot have a paytm account
                </p>
                <p className="myProfile__termsRejection__txt_mWeb">
                  You KYC on paytm is not complete
                </p>
                <p className="myProfile__termsRejection__txt_mWeb">
                  You may have crossed your monthly limit on paytm
                </p>
                <p>
                  3. It may take upto 24 hours after withdrawal request for the money to reflect in
                  your paytm wallet
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="myprofile__withdrawal__container__mWeb" style={{ marginBottom: '0px' }}>
          <button className="myprofile_withdrawal_btn_mWeb" style={withdrawBtnStyle}>
            WITHDRAW
          </button>
        </div>
        <Bottombar />
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default MyProfileMWeb;
